var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "core-js/modules/es6.array.sort", "css-element-queries/src/ResizeSensor", "prop-types", "react", "recompose", "../../../../breakpoints", "../../propTypes", "./Interchange.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("core-js/modules/es6.array.sort"), require("css-element-queries/src/ResizeSensor"), require("prop-types"), require("react"), require("recompose"), require("../../../../breakpoints"), require("../../propTypes"), require("./Interchange.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.es6Array, global.ResizeSensor, global.propTypes, global.react, global.recompose, global.breakpoints, global.propTypes, global.Interchange);
    global.Interchange = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _es6Array, _ResizeSensor, _propTypes, _react, _recompose, _breakpoints, _propTypes2, _Interchange) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.getThumbnail = _exports.getBestImageSize = _exports.getImagesByFormat = _exports.isString = _exports.isObject = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _ResizeSensor = _interopRequireDefault(_ResizeSensor);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _propTypes2 = _interopRequireDefault(_propTypes2);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  /**
   * Helpers to determine the variable type
   */
  var isObject = function isObject(a) {
    return !!a && a.constructor === Object;
  };

  _exports.isObject = isObject;

  var isString = function isString(a) {
    return !!a && typeof a === 'string';
  };
  /**
   * extract the images with the given format
   * @param {Array} imagesSet
   * @param {String} format
   * @param {String} key
   * @returns {Array}
   */


  _exports.isString = isString;

  var getImagesByFormat = function getImagesByFormat(imagesSet, format) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'alternateResolutions';
    var filteredImages = imagesSet.filter(function (image) {
      return 'format' in image && image.format === format;
    });

    if (filteredImages.length && key in filteredImages[0] && filteredImages[0][key].length) {
      return filteredImages[0][key];
    }

    if (filteredImages.length) {
      return filteredImages;
    }

    if (imagesSet.length) {
      return [imagesSet[0]];
    }

    return [];
  };
  /**
   * extract the image with the smallest width for the given format and minimum width
   * @param {Array} imagesSet
   * @param {String} format
   * @param {Number} minimumWidth
   * @returns {String|null}
   */


  _exports.getImagesByFormat = getImagesByFormat;

  var getBestImageSize = function getBestImageSize(imagesSet, format, minimumWidth) {
    var images = getImagesByFormat(imagesSet, format);

    if (images.length === 0) {
      return null;
    }

    var bestImages = images.filter(function (i) {
      return i.width > minimumWidth;
    });
    return !bestImages.length ? images.sort(function (a, b) {
      return b.width - a.width;
    })[0].url : bestImages.sort(function (a, b) {
      return a.width - b.width;
    })[0].url;
  };
  /**
   * extract the thumbnail from the images list
   * @param {Array} imagesSet
   * @param {String} format
   * @returns {String|null}
   */


  _exports.getBestImageSize = getBestImageSize;

  var getThumbnail = function getThumbnail() {
    var imagesSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var images = imagesSet.filter(function (image) {
      return 'format' in image && image.format === format;
    });

    if (images.length === 0) {
      return null;
    }

    if ('blurImages' in images[0]) {
      if (isObject(images[0].blurImages[0])) {
        return images[0].blurImages[0].url;
      } // sometimes blurImages sent by EMAC is directly an url,
      // not an object containing the URL


      if (isString(images[0].blurImages[0])) {
        return images[0].blurImages[0];
      }
    }

    return null;
  };

  _exports.getThumbnail = getThumbnail;

  var getFormat = function getFormat(breakpointFormats) {
    return breakpointFormats[(0, _breakpoints.getCurrentBreakpoint)()];
  };

  var Interchange = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Interchange, _Component);

    var _super = _createSuper(Interchange);

    function Interchange(props) {
      var _this;

      (0, _classCallCheck2.default)(this, Interchange);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onImageLoad", function () {
        _this.setState({
          loaded: true
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateImage", function () {
        var format = getFormat(_this.props.breakpointFormat);
        var elementWidth = _this.root ? _this.root.clientWidth : 0;
        var bestImage = getBestImageSize(_this.props.images, format, elementWidth, 1);

        if (bestImage && bestImage !== _this.state.image) {
          _this.setState({
            format: format,
            image: bestImage
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (ref) {
        _this.root = ref;
      });

      var _format = getFormat(props.breakpointFormat);

      var thumbnail = props.thumbnailEnabled ? getThumbnail(props.images, _format) : null;
      _this.resizeSensor = false;
      _this.state = {
        thumbnail: thumbnail,
        loaded: false,
        image: null,
        format: _format
      };
      return _this;
    }

    (0, _createClass2.default)(Interchange, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.updateImage(this.props);

        try {
          this.resizeSensor = new _ResizeSensor.default(this.root, function () {
            return _this2.updateImage();
          });
        } catch (e) {
          this.resizeSensor = false;
        }
      } // do not trigger useless re-render if component is not visible
      // this is the case for the mobile teaser from MultiLineSlider

    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return nextProps.visible;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // when pictures change / when component becomes visible, pick again the right image url
        // ResizeSensor is not triggered when an invisible element becomes visible after a resize
        // see: https://github.com/marcj/css-element-queries/issues/139
        if (!prevProps.visible && this.props.visible || !(0, _recompose.shallowEqual)(prevProps.images, this.props.images)) {
          this.updateImage();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.resizeSensor) {
          this.resizeSensor.detach(this.root);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            className = _this$props.className,
            hover = _this$props.hover,
            mouseFocus = _this$props.mouseFocus,
            noFocus = _this$props.noFocus,
            placeholder = _this$props.placeholder,
            title = _this$props.title,
            thumbnailEnabled = _this$props.thumbnailEnabled,
            visible = _this$props.visible,
            ariaOptions = _this$props.ariaOptions;
        var _this$state = this.state,
            format = _this$state.format,
            loaded = _this$state.loaded;
        var imageAttributes = {};

        if (title !== '') {
          imageAttributes.title = title;
        }

        return /*#__PURE__*/_react.default.createElement(_Interchange.StyledDiv, {
          className: className,
          ref: this.init,
          _format: format,
          hover: hover,
          hasPlaceholder: !loaded && placeholder,
          mouseFocus: mouseFocus,
          noFocus: noFocus
        }, visible && /*#__PURE__*/_react.default.createElement(_Interchange.StyledImage, (0, _extends2.default)({
          alt: title,
          "aria-hidden": "true",
          className: "interchange-image",
          src: this.state.image,
          onLoad: this.onImageLoad,
          style: {
            opacity: loaded ? 1 : 0
          }
        }, imageAttributes, ariaOptions)), this.state.thumbnail && thumbnailEnabled && /*#__PURE__*/_react.default.createElement(_Interchange.StyledBlurImage, (0, _extends2.default)({
          src: this.state.thumbnail,
          alt: "",
          style: {
            opacity: !loaded ? 1 : 0
          }
        }, ariaOptions)), children);
      }
    }]);
    return Interchange;
  }(_react.Component);

  Interchange.propTypes = {
    breakpointFormat: _propTypes.default.shape({
      xsmall: _propTypes.default.string.isRequired,
      small: _propTypes.default.string.isRequired,
      medium: _propTypes.default.string.isRequired,
      large: _propTypes.default.string.isRequired,
      xlarge: _propTypes.default.string.isRequired,
      xxlarge: _propTypes.default.string.isRequired
    }).isRequired,
    // / ! \ styled can style any component as long as it accepts a className prop.
    // https://emotion.sh/docs/styled)
    className: _propTypes.default.string.isRequired,
    children: _propTypes.default.node,
    hover: _propTypes.default.shape({
      on: _propTypes.default.array,
      off: _propTypes.default.array
    }),
    images: _propTypes.default.arrayOf(_propTypes2.default.image).isRequired,
    mouseFocus: _propTypes.default.bool,
    noFocus: _propTypes.default.bool,
    placeholder: _propTypes.default.bool,
    title: _propTypes.default.string.isRequired,
    thumbnailEnabled: _propTypes.default.bool,
    visible: _propTypes.default.bool,
    ariaOptions: _propTypes.default.shape()
  };
  Interchange.defaultProps = {
    breakpointFormat: {
      xsmall: 'landscape',
      small: 'landscape',
      medium: 'landscape',
      large: 'landscape',
      xlarge: 'landscape',
      xxlarge: 'landscape'
    },
    className: '',
    hover: {
      on: [],
      off: []
    },
    images: [],
    mouseFocus: false,
    noFocus: false,
    placeholder: true,
    thumbnailEnabled: true,
    title: '',
    visible: true,
    ariaOptions: null
  };
  var _default = Interchange;
  _exports.default = _default;
});